import React,{useState, useEffect} from 'react';
import * as actionTypes from '../../../redux/actions/actionTypes';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Input, Form, Select, DatePicker } from 'antd';
import Navigation from '../../Navigation/Navigation';
import salvaStep from '../../../redux/actions/mock/salvaStep';
import { useDispatch, useSelector } from 'react-redux';
import getControlloResidenzaAzienda from '../../../redux/actions/mock/getControlloResidenzaAzienda';
import moment from 'moment';

const SituazioneLavorativa = (props) => {

    const { Option } = Select;

    const datiState = useSelector(state => state.dataReducer);
    const [form] = Form.useForm();
    const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);
    const numPratica = datiState.modello.numPratica;

    const apiPath = useSelector(state => state.dataReducer.dataApiPath);

    const attivitaStore = useSelector(state => state.dataReducer.modello.datiPratica.attivita);
    const tiologiaContrattoStore = useSelector(state => state.dataReducer.modello.datiPratica.tipoContratto);
    
    const errorCodeControlloCAP = useSelector(state => state.dataReducer.controlloCap.errorCode);


    const [attivita,setAttivita] = useState(attivitaStore || null);
    const [tipologiaContrattoDipendente,setTipologiaContrattoDipendente] = useState(tiologiaContrattoStore || null);

    let dateToday = moment().format('YYYY-MM-DD');
    let nextMonth = moment().add(1,'months').format('YYYY-MM-DD');

    const dispatch = useDispatch();

    const capResidenzaAzienda = useSelector(state => state.dataReducer.modello.datiPratica.capAzienda);


    const erroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);

    // const [errorMessageComune, setErrorMessageComune] = useState(null);
    // const [errorMessageProvincia, setErrorMessageProvincia] = useState(null);
    // const [errorMessageTelefonoAzienda, setErrorMessageTelefonoAzienda] = useState(null);
    const [errorMessageDataInizioAttivita, setErrorMessageDataInizioAttivita] = useState(null);
    const [errorMessageDataFineAttivita, setErrorMessageDataFineAttivita] = useState(null);
    const [errorMessageRagioneSociale, setErrorMessageRagioneSociale] = useState(null);
    const [errorMessageAttivita, setErrorMessageAttivita] = useState(null);
    const [errorMessageOccupazioneAutonomo, setErrorMessageOccupazioneAutonomo] = useState(null);
    const [errorMessageOccupazioneDipendente, setErrorMessageOccupazioneDipendente] = useState(null);
    const [errorMessageSettoreAttivita, setErrorMessageSettoreAttivita] = useState(null);
    const [errorMessageTipoContratto, setErrorMessageTipoContratto] = useState(null);

    useEffect( () => {
        if(erroriSalvaStep){
            erroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    // case "comuneAzienda":
                    //     setErrorMessageComune(errore.errorMessage);
                    // break;
                    // case "provinciaAzienda":
                    //     setErrorMessageProvincia(errore.errorMessage);
                    // break; 
                    // case "telefonoAzienda":
                    //     setErrorMessageTelefonoAzienda(errore.errorMessage);
                    // break;
                    case "dataInizioAttivita":
                        setErrorMessageDataInizioAttivita(errore.errorMessage);
                    break;
                    case "dataFineAttivita":
                        setErrorMessageDataFineAttivita(errore.errorMessage);
                    break;
                    case "ragioneSocialeAzienda":
                        setErrorMessageRagioneSociale(errore.errorMessage);
                    break;
                    case "attivita":
                        setErrorMessageAttivita(errore.errorMessage);
                    break;
                    case "occupazioneAutonomo":
                        setErrorMessageOccupazioneAutonomo(errore.errorMessage);
                    break;
                    case "occupazioneDipendente":
                        setErrorMessageOccupazioneDipendente(errore.errorMessage);
                    break;
                    case "settoreAttivita":
                        setErrorMessageSettoreAttivita(errore.errorMessage);
                    break;
                    case "tipoContratto":
                        setErrorMessageTipoContratto(errore.errorMessage);
                    break;
                    default:
                        // setErrorMessageComune(null);
                        // setErrorMessageProvincia(null);
                        // setErrorMessageTelefonoAzienda(null);
                        setErrorMessageDataInizioAttivita(null);
                        setErrorMessageDataFineAttivita(null);
                        setErrorMessageRagioneSociale(null);
                        setErrorMessageAttivita(null);
                        setErrorMessageOccupazioneAutonomo(null);
                        setErrorMessageOccupazioneDipendente(null);
                        setErrorMessageSettoreAttivita(null);
                        setErrorMessageTipoContratto(null);
                    break;
                }
            }); 
        }else{
            // setErrorMessageComune(null);
            // setErrorMessageProvincia(null);
            // setErrorMessageTelefonoAzienda(null);
            setErrorMessageDataInizioAttivita(null);
            setErrorMessageDataFineAttivita(null);
            setErrorMessageRagioneSociale(null);
            setErrorMessageAttivita(null);
            setErrorMessageOccupazioneAutonomo(null);
            setErrorMessageOccupazioneDipendente(null);
            setErrorMessageSettoreAttivita(null);
            setErrorMessageTipoContratto(null);
        }
    },[erroriSalvaStep]);

    const [helpTelefonoAzienda,setHelpTelefonoAzienda] = useState(null);

    useEffect( () => {
        setAttivita(attivitaStore);
    },[attivitaStore])

    useEffect(()=>{
        if(capResidenzaAzienda !== null){
            dispatch(getControlloResidenzaAzienda(capResidenzaAzienda,apiPath,true));
        }
    },[]); // eslint-disable-line

    useEffect(() => {
        form.setFieldsValue(valoriIniziali());
      }, [datiState.modello.datiPratica.attivita]); // eslint-disable-line
  




    function cambioAttivita(valueAttivita){
        dispatch({ type: actionTypes.CAMBIO_ATTIVITA, payload: valueAttivita})
        setAttivita(valueAttivita);
    }



    function cambioTipologiaContrattualeDipendente(tipolgiaContratto){
        setTipologiaContrattoDipendente(tipolgiaContratto);
    }




    function valoriIniziali(){
        let datiRicavati = {};
        const richiesta = datiState.modello.datiPratica || {};
        let nuovaRichiesta= sostituisciDate(richiesta);
          datiRicavati = Object.assign(datiRicavati,nuovaRichiesta);
        return datiRicavati;
      }
  
  
      function sostituisciDate(obj){
          let step = obj;
          let newStep = {};
          //console.log(`Vecchio step: `,step);
          Object.entries(step).forEach(([chiave,dato]) => {
            if(moment(dato,'YYYY-MM-DD',true).isValid()){
              Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM-DD')})
            }else if(moment(dato,'YYYY-MM',true).isValid()){
              Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM')})
            }else{
              Object.assign(newStep,{[chiave]:dato})
            }
          });
      return newStep;
      }



     
 function sostituisciDateSalvaStep(obj){
      let step = obj;
      let newStep = {};
      Object.entries(step).forEach(([chiave,dato]) => {
        if(moment(dato,'YYYY-MM-DDTHH:mm:ssZ',true).isValid()){
          if(chiave === 'tempoResidenza' || chiave === 'dataInizioAttivita' || chiave === 'dataFineAttivita'){
            Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM')});
          }else{
            Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM-DD')});
          }
        }else{
          Object.assign(newStep,{[chiave]:dato});
        }
      });
  return newStep;
  }

    function onFinish(values){
        let valoriDaSlavare = values;
      let nuoviValori = sostituisciDateSalvaStep(valoriDaSlavare);
      dispatch({ type: actionTypes.LOADING_TRUE })
      dispatch({ type: actionTypes.SALVA_DATI, payload: nuoviValori})
      dispatch(salvaStep(datiState.modello.datiPratica, datiState.modello.id,datiState.modello.codiceBroker,datiState.modello.currentStep,apiPath,numPratica));

    }

    
    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Situazione lavorativa' 
                        sottotitolo ='' />

            <Form 
            form={form}
            onFinish={onFinish} 
            initialValues={valoriIniziali()}
            >


            <label className={stylesForm.floatingLabel} htmlFor="attivita">Attività*</label>
                <Form.Item name="attivita" help={errorMessageAttivita}
                        rules={[
                            {
                                required: true,
                                message: 'Scegli l\'attività',
                            }
                        ]}
                >
                <Select onChange={cambioAttivita} placeholder="Seleziona attività*">
                    <Option value="S">Autonomo</Option>
                    <Option value="D">Lavoratore Dipendente</Option>
                    <Option value="P">Pensionato</Option>
                </Select>
                </Form.Item>


            { 
                attivita === 'S' ? (

                    // AUTONOMO
                    <>

                        <label className={stylesForm.floatingLabel} htmlFor="occupazioneAutonomo">Occupazione*</label>
                        <Form.Item name="occupazioneAutonomo" help={errorMessageOccupazioneAutonomo}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli l\'occupazione',
                                        }
                                    ]}
                        >
                            <Select placeholder="Occupazione*">
                                <Option value="ART">Artigiano</Option>
                                <Option value="AUT">Imprenditore</Option>
                                <Option value="PRO">Professionista</Option>
                            </Select>
                        </Form.Item>


                        <label className={stylesForm.floatingLabel} htmlFor="dataInizioAttivita">Data inizio attività*</label>
                        <Form.Item name="dataInizioAttivita" help={errorMessageDataInizioAttivita}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Inserisci la data di inizio attività',
                                        }
                                    ]}
                        >
                            <DatePicker picker="month" placeholder="Seleziona data"  format="MM/YYYY"  disabledDate={d => !d || d.isSameOrBefore('1900-01-01') || d.isSameOrAfter(dateToday)} />
                        </Form.Item>

                    </>

                ) : attivita === 'D' ?
                (
                    // DIPENDENTE
                    <>

                        <label className={stylesForm.floatingLabel} htmlFor="occupazioneDipendente">Occupazione*</label>
                        <Form.Item name="occupazioneDipendente" help={errorMessageOccupazioneDipendente}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli l\'occupazione',
                                        }
                                    ]}
                        >
                            <Select placeholder="Occupazione*">
                                <Option value="OPE">Operaio</Option>
                                <Option value="IMP">Impiegato</Option>
                                <Option value="QUA">Quadro</Option>
                                <Option value="DIR">Dirigente</Option>
                            </Select>
                        </Form.Item>


                        <label className={stylesForm.floatingLabel} htmlFor="settoreAttivita">Settore di attività*</label>
                        <Form.Item name="settoreAttivita" help={errorMessageSettoreAttivita}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli il settore di attività',
                                        }
                                    ]}
                        >
                            <Select placeholder="Settore di attività*">
                                <Option value="P">Privato</Option>
                                <Option value="S">Stato, Parastato Enti Pubblici</Option>
                            </Select>
                        </Form.Item>


                        <label className={stylesForm.floatingLabel} htmlFor="tipoContratto">Tipologia di contratto*</label>
                        <Form.Item name="tipoContratto" help={errorMessageTipoContratto}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Scegli la tipologia di contratto',
                                        }
                                    ]}
                        >
                            <Select
                                placeholder="Tipologia di contratto*"
                                onChange={cambioTipologiaContrattualeDipendente}
                                >
                                <Option value="1">Tempo Indeterminato</Option>
                                <Option value="2">Tempo Determinato</Option>
                                <Option value="3">Part Time Indeterminato</Option>
                                <Option value="4">Part Time Determinato</Option>
                            </Select>
                        </Form.Item>

                        <div className={stylesForm.leftright}>
                            <div className={stylesForm.left}>

                                <label className={stylesForm.floatingLabel} htmlFor="dataInizioAttivita">Data inizio attività*</label>
                                <Form.Item name="dataInizioAttivita"  help={errorMessageDataInizioAttivita}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Inserisci la data di inizio attività',
                                                }
                                            ]}
                                >
                                    <DatePicker picker="month" placeholder="Seleziona data" format="MM/YYYY"  disabledDate={d => !d || d.isSameOrBefore('1900-01-01') || d.isSameOrAfter(dateToday)} />
                                </Form.Item>
                            </div>

                            <div className={stylesForm.right}>
                                {
                                    tipologiaContrattoDipendente === '2' || tipologiaContrattoDipendente === '4'  ? (

                                        <>
                                        <label className={stylesForm.floatingLabel} htmlFor="dataFineAttivita">Data fine attività*</label>
                                        <Form.Item name="dataFineAttivita" help={errorMessageDataFineAttivita}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Inserisci la data di fine attività',
                                            }
                                        ]}
                                        >
                                            <DatePicker picker="month" placeholder="Seleziona data"  format="MM/YYYY"  disabledDate={d => !d || d.isSameOrBefore(nextMonth) || d.isSameOrAfter('2299-01-01')} />
                                        </Form.Item>
                                        </>

                                    ) : ''
                                }
                            </div>
                        </div>

                    </>

                ) : ''

            }

            {

                (attivita === 'S' || attivita === 'D') ? (
                    <>
                        <Form.Item name="ragioneSocialeAzienda" help={errorMessageRagioneSociale}
                            rules={[
                                {
                                    max: 30,
                                    message: 'La ragione sociale non può superare i 30 caratteri',
                                }
                            ]}
                        >
                            <Input maxLength={30} placeholder='ragioneSocialeAzienda' suffix={<label className={stylesForm.floatingLabel} htmlFor="ragioneSocialeAzienda">Ragione sociale azienda (facoltativo)</label>} />
                        </Form.Item>
                    </>
                ) : null
            }

            <Navigation loadingStep={loadingStep} bloccoAvanzamento={!errorCodeControlloCAP && !helpTelefonoAzienda ? false : true} />

            </Form>
        </div>
    )
}

export default SituazioneLavorativa;